export default "__VITE_ASSET__1a07b3ce__"